import React, { useState } from 'react';
import { CheckboxField } from 'src/shared/ui/elements';
import { Collapse, IconButton } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { format, parseISO } from 'date-fns';
import { formatTime } from 'src/coach/service/coach.utils';
import { ShortWeekdays } from '../helper';

export const FranchiseAvailability = ({
  open =false,
  franchise,
  franchisePeriods,
  selectedPeriods,
  onToggleAll,
  onTogglePeriod,
  disabled,
}) => {
  const [collapsed, setCollapsed] = useState(open);

  const toggleCollapse = () => setCollapsed(!collapsed);

  return (
    <div className='tw-ml-4'>
      <div className="tw-flex tw-items-center tw-gap-2">
        <CheckboxField
          disabled={disabled}
          className="tw-items-start tw-accent-red"
          labelClassName="tw-text-[#5f2120] tw-mb-1"
           $label={disabled ? (
                            <span className='tw-font-bold'>
                              {franchise.name}  <span className='tw-font-normal'>(Please contact your manager to update your availability)</span>
                            </span>
                          ) : (
                            <span className='tw-font-bold'>{franchise.name}</span>
                          )}
          checked={franchisePeriods.length > 0 && selectedPeriods.length === franchisePeriods.length}
          indeterminate={
            selectedPeriods.length > 0 &&
            selectedPeriods.length < franchisePeriods.length
          }
          onChange={onToggleAll}
        />
        {!disabled &&
          <IconButton onClick={toggleCollapse} size="small">
            {collapsed ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
      </div>
      <Collapse in={collapsed}>
        <div className="tw-ml-6">
          {franchisePeriods.map((period) => (
            period && (
              <div key={period.id} className="tw-flex tw-items-center">
                <CheckboxField
                  disabled={disabled}
                  className="tw-items-start tw-accent-red"
                  labelClassName="tw-text-[#5f2120] tw-mb-2"
                  $label={`${ShortWeekdays[period.dayOfWeek]}, ${format(parseISO(period.startDate), 'MM/dd/yyyy')} - ${format(parseISO(period.endDate), 'MM/dd/yyyy')} from ${formatTime(period.startTime)} to ${formatTime(period.endTime)}`}
                  checked={selectedPeriods.includes(period.id)}
                  onChange={() => onTogglePeriod(period.id)}
                />
              </div>
            )
          ))}
        </div>
      </Collapse>
    </div>
  );
};
